export function buildShareMessage(code: string, shareUrl: string, lockName: string): string {
    return `Tu acceso a ${lockName}: código ${code}. Tecléalo en el teclado de la puerta. Detalles: ${shareUrl}`;
}
